import Environment from './Environment';
import BaseApi from './BaseApi';

class VideoApi extends BaseApi {
  constructor() {
    super();
    this.url = Environment.videoApi;
    this.path = 'v1/clips';
  }
}

export default new VideoApi();



// WEBPACK FOOTER //
// ./src/api/VideoApi.js